{
  "UI Elements": "عناصر واجهة المستخدم",
  "Forms & Tables": "النماذج والجداول",
  "Pages": "الصفحات",
  "Charts & Maps": "الرسوم البيانية والخرائط",
  "Others": "آحرون",
  "Typography": "الطباعة",
  "Cards": "البطاقات",
  "Basic": "أساسي",
  "Advance": "يتقدم",
  "Widgets": "الحاجيات",
  "Actions": "أجراءات",
  "Components": "عناصر",
  "Alert": "انذار",
  "Close Alert": "أغلق التنبيه",
  "Avatar": "الصورة الرمزية",
  "Badge": "شارة",
  "Button": "زر",
  "Calendar": "تقويم",
  "Image": "صورة",
  "Pagination": "ترقيم الصفحات",
  "Progress Circular": "تقدم التعميم",
  "Progress Linear": "تقدم خطي",
  "Autocomplete": "الإكمال التلقائي",
  "Tooltip": "تلميح",
  "Slider": "المنزلق",
  "Date Time Picker": "منتقي التاريخ والوقت",
  "Select": "يختار",
  "Switch": "يُحوّل",
  "Checkbox": "خانة اختيار",
  "Radio": "مذياع",
  "Textarea": "تيكستاريا",
  "Rating": "تقييم",
  "File Input": "إدخال الملف",
  "Otp Input": "إدخال أوتب",
  "Form Layout": "تخطيط النموذج",
  "Form Validation": "التحقق من صحة النموذج",
  "Charts": "الرسوم البيانية",
  "Apex Chart": "مخطط أبيكس",
  "Chartjs": "تشارتجس",
  "Account Settings": "إعدادت الحساب",
  "User Profile": "ملف تعريفي للمستخدم",
  "FAQ": "التعليمات",
  "Dialog Examples": "أمثلة على الحوار",
  "Pricing": "التسعير",
  "List": "قائمة",
  "Edit": "يحرر",
  "Nav Levels": "مستويات التنقل",
  "Level 2.1": "المستوى 2.1",
  "Level 2.2": "مستوى 2.2",
  "Level 3.1": "المستوى 3.1",
  "Level 3.2": "المستوى 3.2",
  "Raise Support": "رفع الدعم",
  "Documentation": "توثيق",
  "Dashboards": "لوحات القيادة",
  "Apps & Pages": "التطبيقات والصفحات",
  "Email": "البريد الإلكتروني",
  "Chat": "دردشة",
  "Invoice": "فاتورة",
  "Preview": "معاينة",
  "Add": "يضيف",
  "User": "المستعمل",
  "View": "رأي",
  "Login v1": "تسجيل الدخول v1",
  "Login v2": "تسجيل الدخول v2",
  "Login": "تسجيل الدخول",
  "Register v1": "تسجيل v1",
  "Register v2": "تسجيل v2",
  "Register": "تسجيل",
  "Forget Password v1": "نسيت كلمة المرور v1",
  "Forget Password v2": "نسيت كلمة المرور v2",
  "Forgot Password v1": "نسيت كلمة المرور v1",
  "Forgot Password v2": "نسيت كلمة المرور v2",
  "Forgot Password": "نسيت كلمة المرور",
  "Reset Password v1": "إعادة تعيين كلمة المرور v1",
  "Reset Password v2": "إعادة تعيين كلمة المرور v2",
  "Reset Password": "إعادة تعيين كلمة المرور",
  "Miscellaneous": "متفرقات",
  "Coming Soon": "قريبا",
  "Not Authorized": "غير مخول",
  "Under Maintenance": "تحت الصيانة",
  "Error": "خطأ",
  "Statistics": "إحصائيات",
  "Analytics": "تحليلات",
  "Access Control": "صلاحية التحكم صلاحية الدخول",
  "User Interface": "واجهة المستخدم",
  "CRM": "سي آر إم",
  "Icons": "أيقونات",
  "Chip": "رقاقة",
  "Dialog": "حوار",
  "Expansion Panel": "لوحة التوسع",
  "Combobox": "صندوق التحرير",
  "Textfield": "مجال التحرير مكان كتابة النص",
  "Range Slider": "نطاق المنزلق",
  "Menu": "قائمة الطعام",
  "Snackbar": "مطعم الوجبات الخفيفة",
  "Tabs": "نوافذ التبويب",
  "Form Elements": "عناصر النموذج",
  "Form Layouts": "تخطيطات النموذج",
  "Authentication": "المصادقة",
  "Page Not Found - 404": "الصفحة غير موجودة - 404",
  "Not Authorized - 401": "غير مصرح - 401",
  "Server Error - 500": "خطأ في الخادم - 500",
  "2": "2",
  "Forms": "نماذج",
  "Timeline": "الجدول الزمني",
  "Disabled Menu": "قائمة المعوقين",
  "Help Center": "مركز المساعدة",
  "Verify Email": "التحقق من البريد الإلكتروني",
  "Verify Email v1": "تحقق من البريد الإلكتروني v1",
  "Verify Email v2": "تحقق من البريد الإلكتروني v2",
  "Two Steps": "خطوتين",
  "Two Steps v1": "خطوتين v1.0",
  "Two Steps v2": "خطوتين v2.0",
  "Custom Input": "إدخال مخصص",
  "Extensions": "ملحقات",
  "Tour": "رحلة",
  "Register Multi-Steps": "تسجيل خطوات متعددة",
  "Wizard Examples": "أمثلة المعالج",
  "Checkout": "الدفع",
  "Create Deal": "إنشاء صفقة",
  "Property Listing": "قائمة الممتلكات ",
  "Roles & Permissions": "الأدوار والأذونات",
  "Roles": "الأدوار",
  "Permissions": "الأذونات",
  "Simple Table": "جدول بسيط",
  "Tables": "الجداول",
  "DataTable": "جدول البيانات",
  "Data Table": "جدول البيانات",
  "Apps": "التطبيقات",
  "Misc": "متفرقات",
  "Wizard Pages": "صفحات المعالج",
  "eCommerce": "التجارة الإلكترونية",
  "Form Wizard": "معالج النموذج",
  "Numbered": "مرقم",
  "ecommerce": "التجارة الإلكترونية",
  "Ecommerce": "التجارة الإلكترونية",
  "Product": "المنتج",
  "Category": "الفئة",
  "Order": "طلب",
  "Details": "تفاصيل",
  "Customer": "الزبون",
  "Manage Review": "إدارة المراجعة",
  "Referrals": "الإحالات",
  "Settings": "الإعدادات",
  "Course Details": "تفاصيل الدورة التدريبية",
  "My Course": "دورتي",
  "Overview": "نظرة عامة",
  "Academy": "أكاديمية",
  "Logistics": "الخدمات اللوجستية",
  "Dashboard": "لوحة القيادة",
  "Fleet": "الأسطول",
  "Editors": "المحررين",
  "Front Pages": "الصفحات الأمامية",
  "Landing": "المقصودة",
  "checkout": "الدفع",
  "Payment": "دفع",
  "Swiper": "المنزلق",
  "3": "3",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "login": {
    "errors": {
      "signInFailed": "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
      "noAccess": "هذا الحساب ليس لديه صلاحية الوصول إلى لوحة الإدارة.",
      "invalidCredentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
      "missingCredentials": "أدخل البريد الإلكتروني وكلمة المرور."
    },
    "googleCta": "تسجيل الدخول بحساب Google",
    "orDivider": "أو",
    "emailLabel": "البريد الإلكتروني",
    "passwordLabel": "كلمة المرور",
    "loginCta": "تسجيل الدخول"
  },
  "orders": {
    "filters": {
      "title": "التخطيط"
    },
    "plan": {
      "title": "التخطيط",
      "destinationLabel": "وجهة القيادة",
      "dateLabel": "تاريخ الاستحقاق",
      "applyCta": "خطّط",
      "resetCta": "إعادة تعيين",
      "exportCta": "تصدير CSV",
      "selectDate": "اختر تاريخًا لتحميل الخطة",
      "loading": "جارٍ التحميل…",
      "empty": "لا توجد إجراءات لهذا التاريخ",
      "columns": {
        "order": "الطلب",
        "action": "الإجراء",
        "name": "الاسم",
        "address": "العنوان",
        "suite": "شقة",
        "timeWindows": "نوافذ الوقت",
        "phone": "الهاتف",
        "type": "النوع",
        "driver": "السائق"
      },
      "driverLabel": "السائق",
      "allDrivers": "جميع السائقين",
      "unassigned": "غير معيّن",
      "overdueSince": "مستحقة في {date}"
    },
    "activeViews": {
      "default": "العرض الافتراضي",
      "driving": "عرض القيادة"
    },
    "active": {
      "drive": "قيادة",
      "success": "نجاح",
      "failed": "فشل",
      "empty": "لا توجد طلبات نشطة",
      "due": "مستحق",
      "callContact": "اتصال",
      "messageOnWhatsApp": "رسالة",
      "customerComment": "تعليق العميل",
      "moneyNotSecured": "المبلغ غير مؤمَّن",
      "confirmFutureAction": {
        "title": "تأكيد الإجراء",
        "message": "هذا الإجراء ليس مستحقًا اليوم. هل أنت متأكد من المتابعة؟",
        "confirm": "نعم، تابع",
        "cancel": "إلغاء"
      },
      "actions": {
        "customerPickup": "استلام من العميل",
        "customerDelivery": "تسليم للعميل",
        "storePickup": "استلام من المتجر",
        "storeDelivery": "تسليم للمتجر"
      }
    },
    "details": {
      "noAccess": "لم تعد هذه الطلبية مُسندة إليك، لذا لا يمكن فتحها هنا.",
      "noAccessBack": "العودة إلى قيادتي"
    },
    "dispatch": {
      "title": "التوزيع",
      "driverLabel": "السائق المُسنَد",
      "pickupDate": "تاريخ الاستلام الفعلي",
      "pickupWindow": "نافذة الاستلام الفعلية",
      "deliveryDate": "تاريخ التسليم الفعلي",
      "deliveryWindow": "نافذة التسليم الفعلية",
      "notPlanned": "لم تُجدول بعد",
      "assignedTo": "مُسنَد إلى {name}"
    }
  },
  "$vuetify": {
    "badge": "شارة",
    "noDataText": "لا تتوافر بيانات",
    "close": "قريب",
    "open": "افتح",
    "carousel": {
      "ariaLabel": {
        "delimiter": "تحديد"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "مواد لكل صفحة:",
      "itemsPerPageAll": "الجميع",
      "pageText": "{0} - {1} من {2}",
      "firstPage": "الصفحة الأولى",
      "prevPage": "الصفحة السابقة",
      "nextPage": "الصفحة التالية",
      "lastPage": "آخر صفحة"
    },
    "pagination": {
      "ariaLabel": {
        "root": "جذر",
        "previous": "السابق",
        "next": "التالي",
        "currentPage": "الصفحه الحاليه",
        "page": "صفحة"
      }
    },
    "input": {
      "clear": "صافي",
      "appendAction": "إلحاق الإجراء",
      "prependAction": "قبل العمل",
      "otp": "أوتب"
    },
    "fileInput": {
      "counterSize": "حجم العداد"
    },
    "rating": {
      "ariaLabel": {
        "item": "العنصر"
      }
    }
  },
  "driver": {
    "myActions": {
      "title": "رحلاتي",
      "dateLabel": "التاريخ",
      "refresh": "تحديث",
      "todaySubtitle": "كل ما تم تعيينه لك اليوم، بالترتيب القابل للتنفيذ.",
      "otherDaySubtitle": "كل ما تم تعيينه لك في هذا التاريخ.",
      "loading": "جارٍ تحميل يومك…",
      "empty": "لا يوجد شيء معين لك في هذا التاريخ.",
      "emptyHint": "تظهر الطلبات هنا بعد أن يعيّنها لك المسؤول من صفحة الخطة."
    },
    "blocked": {
      "earlierStepPending": "أنجز الخطوة السابقة أولاً",
      "operiClosed": "يوم غير عمل",
      "generic": "غير ممكن اليوم"
    },
    "delivery": {
      "title": "إتمام التوصيل {order}",
      "amountToCollect": "المبلغ المطلوب:",
      "tenderQuestion": "بماذا دفع العميل؟",
      "alreadyPaid": "مدفوع مسبقاً — لا شيء للتحصيل عند الباب.",
      "tender": {
        "cash": "نقداً",
        "card": "بطاقة على الجهاز",
        "notCollected": "لم يتم التحصيل"
      },
      "overrideLabel": "التوصيل دون تحصيل المبلغ",
      "overrideReasonLabel": "لماذا؟",
      "confirm": "تأكيد التوصيل",
      "cancel": "إلغاء",
      "failed": "تعذر إتمام التوصيل.",
      "loadFailed": "تعذر تحميل بيانات الدفع للطلب."
    },
    "order": {
      "loading": "جارٍ تحميل الطلب…",
      "back": "العودة إلى رحلاتي",
      "customer": "العميل",
      "amount": "المبلغ",
      "pickup": "عنوان الاستلام",
      "delivery": "عنوان التوصيل",
      "customerComment": "ملاحظة العميل"
    },
    "overdue": "متأخرة {days} يوم"
  },
  "availability": {
    "pickup": "الاستلام",
    "delivery": "التوصيل",
    "tabs": {
      "calendar": "التقويم",
      "nonWorking": "أيام العطل",
      "weekly": "الإغلاق الأسبوعي",
      "reasons": "الأسباب"
    },
    "state": {
      "open": "متاح للحجز",
      "beyond": "خارج الأيام المعروضة",
      "closed": "مغلق",
      "windowsClosed": "جميع الفترات مغلقة",
      "nonWorking": "يوم عطلة",
      "past": "منقضٍ"
    },
    "scope": {
      "OPERI": "أوبيري",
      "LAUNDRY": "المغسلة",
      "BOTH": "كلاهما"
    },
    "reason": {
      "PAST": "في الماضي",
      "WEEKLY_NON_WORKING": "إغلاق أسبوعي",
      "NON_WORKING_DAY": "يوم عطلة",
      "DAY_CLOSED": "أغلقه المسؤول",
      "ALL_WINDOWS_CLOSED": "جميع الفترات مغلقة",
      "BEYOND_HORIZON": "خارج الأيام المعروضة حالياً",
      "TOO_EARLY": "مبكر جدًا — لا شيء يُجمع الآن يعود بحلول ذلك الوقت"
    },
    "window": {
      "OPEN": "مفتوح",
      "CLOSED": "مغلق",
      "PASSED": "منقضٍ",
      "NON_WORKING": "يوم عطلة"
    },
    "drawer": {
      "bookable": "متاح للحجز",
      "wholeDay": "اليوم بالكامل",
      "dayClosed": "هذا التاريخ مغلق للحجوزات.",
      "reopenDay": "إعادة فتح اليوم",
      "reasonLabel": "السبب",
      "noteLabel": "ملاحظة (اختياري)",
      "closeDay": "إغلاق اليوم بالكامل",
      "nothingToDecide": "لا شيء لإغلاقه — التاريخ غير متاح أصلاً.",
      "windows": "الفترات الزمنية",
      "reopen": "إعادة الفتح",
      "close": "إغلاق",
      "notClosable": "غير متاح أصلاً",
      "planner": "إجراءات القيادة",
      "opening": "خارج الأيام المعروضة",
      "openDay": "افتح هذا اليوم",
      "openDayHint": "لا مشكلة في هذا التاريخ، لكنه أبعد من الأيام المعروضة على العملاء. فتحه يجعله تاريخ استلام إضافيًا.",
      "dayOpened": "مفتوح يدويًا، لذا يُعرض على العملاء إضافةً إلى الأيام المعتادة.",
      "removeOpening": "أوقف عرضه"
    },
    "reasons": {
      "nameLabel": "سبب جديد",
      "add": "إضافة",
      "name": "السبب",
      "status": "",
      "restore": "استعادة",
      "archive": "أرشفة",
      "empty": "لا توجد أسباب بعد."
    },
    "nonWorking": {
      "dateLabel": "التاريخ",
      "scopeLabel": "من لا يعمل",
      "reasonLabel": "السبب",
      "add": "إضافة",
      "date": "التاريخ",
      "scope": "من لا يعمل",
      "reason": "السبب",
      "remove": "إزالة",
      "empty": "لا توجد أيام عطل في السنة القادمة."
    },
    "weekly": {
      "explainer": "إغلاق دائم، كل أسبوع. أوبيري ليس لديها إغلاق عادةً — تعمل سبعة أيام — بينما المغسلة مغلقة أيام الأحد. تغيير هذا يغيّر التواريخ المعروضة على العملاء.",
      "OPERI": "أوبيري لا تعمل",
      "LAUNDRY": "المغسلة لا تعمل",
      "save": "حفظ",
      "saved": "تم الحفظ"
    },
    "weekday": {
      "MONDAY": "الإثنين",
      "TUESDAY": "الثلاثاء",
      "WEDNESDAY": "الأربعاء",
      "THURSDAY": "الخميس",
      "FRIDAY": "الجمعة",
      "SATURDAY": "السبت",
      "SUNDAY": "الأحد"
    },
    "planner": {
      "loading": "جارٍ تحميل الخطة…",
      "empty": "لا يوجد شيء مخطط لهذا التاريخ.",
      "customerPrefers": "العميل متاح في:",
      "notPlanned": "غير مخطط بعد",
      "outsidePreference": "خارج الفترات التي اختارها العميل",
      "storeLegs": "التسليم مع المغسلة (بدون فترة للعميل)",
      "operiClosed": "لا أحد يقود في هذا التاريخ. تم نقل العمل إلى يوم العمل التالي.",
      "laundryClosed": "إغلاق المغسلة يضيف يوم معالجة. أما الرحلات من وإليها فلا تتأثر.",
      "windowLabel": "النافذة الفعلية",
      "hiddenByFilter": "{count} مخفية بسبب عامل تصفية السائق",
      "emptyForDriver": "لا يوجد شيء في هذا التاريخ يطابق عامل تصفية السائق.",
      "noWindowToPlan": "لا توجد نافذة للجدولة — تسليم إلى المغسلة"
    },
    "dayPanel": {
      "editAvailability": "تعديل التوفر",
      "openWindows": "{open} من {total} فترات مفتوحة"
    },
    "calendar": {
      "windowsShort": "{open}/{total} نافذة",
      "windowsTitle": "{open} من {total} نافذة حجز مفتوحة",
      "actionsTitle": "{side}: {orders} طلبية ({customer} محطة عميل، {store} تسليم للمتجر)",
      "legendLoad": "طلبيات للتنظيم",
      "legendNonWorking": "غير عامل",
      "nonWorking": {
        "OPERI": "أوبيري لا تقود",
        "LAUNDRY": "المغسلة مغلقة",
        "BOTH": "أوبيري والمغسلة مغلقتان"
      },
      "openedShort": "مفتوح",
      "legendOpened": "مفتوح يدويًا",
      "openedTitle": "مفتوح يدويًا، إضافةً إلى الأيام المعروضة"
    }
  }
}
